/**
 * TeleCajas consent stash → cart attributes (L2).
 * Loads from theme (NOT custom pixel sandbox — pixels cannot reliably POST /cart/update.js).
 * Writes after Customer Privacy decision: tc_analytics, tc_marketing, tc_consent_at,
 * and if analytics=yes: tc_ga_client_id, tc_ga_session_id from _ga / _ga_*.
 * Does NOT change checkout UX.
 */
(function () {
  "use strict";
  var MEASUREMENT = "G-F2SLNT37WC";
  var STREAM_COOKIE = "_ga_F2SLNT37WC";
  var lastPayload = "";
  var pending = null;

  function cookie(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : "";
  }

  function gaClientId() {
    var ga = cookie("_ga");
    if (!ga) return "";
    var parts = ga.split(".");
    if (parts.length >= 4) return parts[parts.length - 2] + "." + parts[parts.length - 1];
    return ga;
  }

  function gaSessionId() {
    var c = cookie(STREAM_COOKIE);
    if (!c) return "";
    // GS2.1.sSESSION$... or GS1.1.SESSION.TIMESTAMP...
    var m = c.match(/\.s(\d+)/);
    if (m) return m[1];
    var parts = c.split(".");
    for (var i = 0; i < parts.length; i++) {
      if (/^\d{8,}$/.test(parts[i])) return parts[i];
    }
    return "";
  }

  function readConsent(cp) {
    var analytics = false;
    var marketing = false;
    try {
      if (typeof cp.analyticsProcessingAllowed === "function") {
        analytics = !!cp.analyticsProcessingAllowed();
      } else if (cp.consent) {
        analytics = cp.consent.analytics === "yes" || cp.consent.analytics === true;
      }
      if (typeof cp.marketingAllowed === "function") {
        marketing = !!cp.marketingAllowed();
      } else if (cp.consent) {
        marketing = cp.consent.marketing === "yes" || cp.consent.marketing === true;
      }
    } catch (e) {}
    return { analytics: analytics, marketing: marketing };
  }

  function hasInteracted(cp) {
    try {
      if (typeof cp.getTrackingConsent === "function") {
        var t = cp.getTrackingConsent();
        if (t && t !== "no_interaction") return true;
      }
      if (typeof cp.currentVisitorConsent === "function") {
        var v = cp.currentVisitorConsent();
        if (v && (v.analytics || v.marketing || v.preferences)) return true;
      }
    } catch (e) {}
    // Fallback: if either API reports a definitive allow/deny after banner UI
    return false;
  }

  function stash(force) {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return;
    var interacted = hasInteracted(cp);
    var c = readConsent(cp);
    // Always write yes|no after interaction; never invent yes without decision
    if (!interacted && !force) {
      // If APIs already return boolean false after reject, treat as interacted
      if (c.analytics === false && c.marketing === false) {
        try {
          if (typeof cp.getTrackingConsent === "function" && cp.getTrackingConsent() === "no") {
            interacted = true;
          }
        } catch (e) {}
      }
      if (!interacted) return;
    }
    var attrs = {
      tc_analytics: c.analytics ? "yes" : "no",
      tc_marketing: c.marketing ? "yes" : "no",
      tc_consent_at: new Date().toISOString(),
    };
    if (c.analytics) {
      var cid = gaClientId();
      var sid = gaSessionId();
      if (cid) attrs.tc_ga_client_id = cid;
      if (sid) attrs.tc_ga_session_id = sid;
    }
    var body = JSON.stringify({ attributes: attrs });
    if (body === lastPayload) return;
    lastPayload = body;
    if (pending) return;
    pending = fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: body,
    })
      .catch(function () {})
      .finally(function () {
        pending = null;
      });
  }

  function onReady() {
    stash(false);
    document.addEventListener("visitorConsentCollected", function () {
      setTimeout(function () {
        stash(true);
      }, 50);
    });
    // Re-try briefly while CMP settles / cookies land after accept
    var n = 0;
    var t = setInterval(function () {
      stash(false);
      if (++n > 20) clearInterval(t);
    }, 1000);
  }

  if (window.Shopify && window.Shopify.customerPrivacy) onReady();
  else if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
      if (!err) onReady();
    });
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(onReady, 500);
    });
  }
})();
